export interface DocumentInsertionPoint {
  referenceContentControlId: number;
  referenceDocumentId: string;
  position: "before" | "after";
}

export const checkIfPartExists = (contentControlId: number): void => {
  if (!contentControlId) {
    throw new Error("Invalid document part include or missing content control ID.");
  }
};

export const getContentControlById = async (context: Word.RequestContext, contentControlId: number) => {
  const contentControls = context.document.contentControls;
  contentControls.load();
  await context.sync();
  return contentControls.items.find((cc) => cc.id === contentControlId);
};

export const insertDocumentPart = async (
  title: string,
  documentInsertionPoint?: DocumentInsertionPoint
): Promise<Word.ContentControl> => {
  return Word.run(async (context) => {
    const EMPTY_TEXT = "";
    let paragraph: Word.Paragraph;

    if (documentInsertionPoint) {
      const selectedCc = await getContentControlById(context, documentInsertionPoint.referenceContentControlId);
      if (!selectedCc) {
        throw new Error(
          `No content control found for the given id: ${documentInsertionPoint.referenceContentControlId}`
        );
      }

      paragraph = selectedCc.insertParagraph(
        EMPTY_TEXT,
        documentInsertionPoint.position === "before" ? Word.InsertLocation.before : Word.InsertLocation.after
      );
      selectedCc.insertParagraph(
        EMPTY_TEXT,
        documentInsertionPoint.position === "before" ? Word.InsertLocation.before : Word.InsertLocation.after
      );
    } else {
      const emptyParagraph = context.document.body.insertParagraph(EMPTY_TEXT, Word.InsertLocation.end);
      paragraph = emptyParagraph.insertParagraph(EMPTY_TEXT, Word.InsertLocation.after);
    }

    const cc = paragraph.insertContentControl();

    cc.title = title;
    cc.cannotEdit = true;
    cc.cannotDelete = true;

    await context.sync();
    return cc;
  }).catch((error) => {
    console.error(error);
    throw error;
  });
};

export const moveCursorToContentControlId = (contentControlId: number) =>
  new Promise<void>((resolve, reject) =>
    Word.run(async (context) => {
      const contentControl = context.document.contentControls.getByIdOrNullObject(Number(contentControlId));
      await context.sync();
      if (contentControl.isNullObject) throw new Error(`No contentControl found for the given id ${contentControlId}`);
      contentControl.select();
      resolve();
    }).catch((error) => {
      console.error(error);
      reject(error instanceof Error ? error : new Error(String(error)));
    })
  );

export const moveCursorToContentControl = (contentControlId: number) =>
  new Promise<void>((resolve, reject) =>
    Word.run(async (context) => {
      const contentControl = context.document.contentControls.getByIdOrNullObject(Number(contentControlId));
      await context.sync();
      if (contentControl.isNullObject) throw new Error(`No contentControl found for the given id ${contentControlId}`);
      contentControl.select();
      await context.sync();
      resolve();
    }).catch((error) => {
      console.error(error);
      reject(error instanceof Error ? error : new Error(String(error)));
    })
  );
